import { useEffect, useState } from "react";
import {fetchSensorCRAgg} from "../../../api/sensorApi";


function useFetchCRDetails(sensorID, start, end) {

    const [CRDetailsData, setCRDetailsData] = useState(null);

    useEffect(() => {
        fetchSensorCRAgg({
            subject_filter: `sensor.id = '${sensorID}'`,
            selectedStartDate: start.format("YYYY-MM-DD"),
            selectedEndDate: end.format("YYYY-MM-DD"),
        }).then((CRDetailData) => {
            if (
                CRDetailData?.longTermCR !== null ||
                CRDetailData?.longTermCR !== undefined
            ) {
                console.log("CRDetailData", CRDetailData);
                setCRDetailsData(CRDetailData[0]);
            }
        }).catch((error) => { console.log(error) });
    }, [sensorID, start, end]);

    return { CRDetailsData };

}

export default useFetchCRDetails;